import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function listPlaceRatings(params) {
  return request({
    url: ENDPOINT.PLACE_RATINGS,
    method: 'get',
    params
  })
}

export function createPlaceRating(data) {
  return request({
    url: ENDPOINT.PLACE_RATINGS,
    method: 'post',
    data
  })
}

export function deletePlaceRating(params) {
  return request({
    url: ENDPOINT.PLACE_RATINGS,
    method: 'delete',
    params
  })
}

export function updatePlaceRating(data) {
  return request({
    url: ENDPOINT.PLACE_RATINGS,
    method: 'patch',
    data
  })
}

export async function syncRatingData(params = {}) {
  const { external_id = '', source_url = '', origin = '' } = params
  let detectedOrigin = origin
  let detectedExternalId = external_id
  let rating = 5
  const extra_data = { helpful_votes: 0 }

  if (source_url) {
    const urlStr = source_url.trim()

    // 1. Detect Google origin & extract external_id
    if (urlStr.includes('google.com') || urlStr.includes('goo.gl') || urlStr.includes('maps.app.goo.gl')) {
      detectedOrigin = 'google'
      if (!detectedExternalId) {
        // e.g. https://maps.app.goo.gl/eomcdzcy2FNFM3i8A
        const matchShort = urlStr.match(/(?:maps\.app\.goo\.gl|goo\.gl\/maps)\/([a-zA-Z0-9_-]+)/)
        if (matchShort && matchShort[1]) {
          detectedExternalId = matchShort[1]
        } else {
          const matchParam = urlStr.match(/!1s([a-zA-Z0-9_-]+)/)
          if (matchParam && matchParam[1]) {
            detectedExternalId = matchParam[1]
          } else {
            const matchPlace = urlStr.match(/\/place\/([^/]+)/)
            if (matchPlace && matchPlace[1]) {
              detectedExternalId = decodeURIComponent(matchPlace[1])
            }
          }
        }
      }
    } else if (urlStr.includes('booking.com')) {
      detectedOrigin = 'booking'
      if (!detectedExternalId) {
        const matchBooking = urlStr.match(/\/hotel\/[a-z]{2}\/([^/.?]+)/)
        if (matchBooking && matchBooking[1]) {
          detectedExternalId = matchBooking[1]
        }
      }
    }

    // 2. Parse query parameters if present
    try {
      if (urlStr.includes('?')) {
        const searchString = urlStr.split('?')[1]
        const urlParams = new URLSearchParams(searchString)

        if (urlParams.has('rating')) {
          const r = parseFloat(urlParams.get('rating'))
          if (!isNaN(r) && r >= 1 && r <= 5) rating = r
        } else if (urlParams.has('rate')) {
          const r = parseFloat(urlParams.get('rate'))
          if (!isNaN(r) && r >= 1 && r <= 5) rating = r
        }

        if (urlParams.has('helpful_votes')) {
          const hv = parseInt(urlParams.get('helpful_votes'), 10)
          if (!isNaN(hv)) extra_data.helpful_votes = hv
        } else if (urlParams.has('votes')) {
          const hv = parseInt(urlParams.get('votes'), 10)
          if (!isNaN(hv)) extra_data.helpful_votes = hv
        }
      }
    } catch (e) {
      // ignore parse errors
    }
  }

  return {
    rating,
    extra_data,
    origin: detectedOrigin || 'google',
    external_id: detectedExternalId
  }
}

